import { AnimatePresence, motion } from 'motion/react'
import { useEffect } from 'react'
import type { RoomError } from '../store/shared'

export function Toast({ error, onDismiss }: { error: RoomError | null; onDismiss: () => void }) {
  useEffect(() => {
    if (!error) return
    const id = setTimeout(onDismiss, 2500)
    return () => clearTimeout(id)
  }, [error, onDismiss])

  return (
    <AnimatePresence>
      {error && (
        <motion.div
          role="status"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          className="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+1rem)] z-30 flex justify-center px-4"
        >
          <div className="rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white shadow-lg dark:bg-white dark:text-slate-900">
            {error.message}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
